import { useMemo } from "react";

const useFormattedPhoneHide = (numero: string | null | undefined): string => {
  return useMemo(() => {
    // Verificar se o número é nulo ou undefined
    if (!numero) return "--";

    // Remover todos os caracteres não numéricos
    const numeroApenasDigitos = numero.replace(/\D/g, "");
    const tamanhoNumero = numeroApenasDigitos.length;

    if (tamanhoNumero === 13) {
      return `+${numeroApenasDigitos.slice(0, 2)} (${numeroApenasDigitos.slice(
        2,
        4
      )}) *****-${numeroApenasDigitos.slice(9)}`;
    }
    if (tamanhoNumero === 12) {
      return `+${numeroApenasDigitos.slice(0, 2)} (${numeroApenasDigitos.slice(
        2,
        4
      )}) ****-${numeroApenasDigitos.slice(8)}`;
    }
    if (tamanhoNumero === 11) {
      return `(${numeroApenasDigitos.slice(
        0,
        2
      )}) *****-${numeroApenasDigitos.slice(7)}`;
    }
    if (tamanhoNumero === 10) {
      return `(${numeroApenasDigitos.slice(
        0,
        2
      )}) ****-${numeroApenasDigitos.slice(6)}`;
    }

    // Retorna o número sem formatação se não for possível mascarar
    return numeroApenasDigitos;
  }, [numero]);
};

export default useFormattedPhoneHide;
